var visualElementStore=new WeakMap();export{visualElementStore};